export const Arabic = {
	competition: "مسابقة",
	americano: "أمريكانو",
	court_name: "إسم الملعب",
	court_price_team: "سعر الملعب/الفريق",
	court_price_player: "سعر الملعب/اللاعب",
	usage_count: "عدد الاستخدام",
	normal: "عادي",
	subscription_type: "نوع الاشتراك",
	qr: "QR",
	general: "عام",
	total_leave_parkings: "إجمالي مواقف السيارات",
	cars_services: "خدمات السيارات",
	total_quick_valet: "إجمالي خدمة السيارات السريعة",
	client: "عميل",
	total_matches: "إجمالي المباريات",
	total_packages: "إجمالي الباقات",
	pinMark: "إجمالي المثبتة في السوق",
	total_products: "إجمالي المنتجات",
	send_email: "إرسال البريد الإلكتروني",
	tournament_type: "نوع البطولة",
	players: "لاعبين",
	invite: "دعوه",
	player: "لاعب",
	total_clients: "إجمالي العملاء",
	total_income: "إجمالي الدخل",
	total_drivers: "إجمالي السائقين",
	average_service_time: "متوسط ​​وقت الخدمة",
	zone_name: "اسم المنطقة",
	beginner: "مبتدئ",
	intermediate: "متوسط",
	advanced: "متقدم",
	age: "العمر",
	is_court_booked: "هل تم حجز الملعب",
	match_type: "نوع المباراة",
	match_double: "مطابقة مزدوجة",
	single_double: "مزدوج مفرد",
	double: "مزدوج",
	duration_of_the_match: "مدة المباراة",
	number_of_cars: "عدد السيارات",
	total_earning: "إجمالي الأرباح",
	courts: "الملاعب",
	court: "ملعب",
	level: "المستوى",
	court_booking: "حجز الملعب",
	market_place: "السوق",
	map: "خريطة",
	verified: "تم التحقق",
	not_verified: "غير مُتحقق",
	no_of_orders: "عدد الطلبات",
	no_of_matches: "عدد المباريات",
	matches: "المطابقات",
	question: "سؤال",
	answer: "إجابه",
	added_by: "أُضيف بواسطة",
	confirmed: "مؤكد",
	used: "مُستخدَم",
	pin_market_place: "تثبيت السوق",
	booking_managment: "إدارة الحجز",
	booking_management: "إدارة الحجز",
	booking_requests: "طلبات الحجز",
	all_booking: "جميع الحجوزات",
	subscription: "اشتراك",
	subscription_type: "نوع الإشتراك",
	subscriptions: "اشتراكات",
	about_us: "نبذة عنا",
	number_of_teams: "عدد الفرق",
	advertisement_splash: "إعلان ترويجي",
	onboarding: "التوجيه",
	packages: "باقات",
	package: "باقه",
	tournaments: "البطولات",
	number_of_team: "عدد الفرق",
	tournament: "بطوله",
	tournament_name: "إسم البطوله",
	booking: "حجز",
	category_managment: "إدارة الفئات",
	staf_dirvers_reports: "تقارير الموظفين والسائقين",
	staff: "الموظفين",
	zones_report: "تقرير المناطق",
	qr_code: "رموز الاستجابة السريعة",
	qr_code_group: "مجموعة رموز الاستجابة السريعة",
	qr_code_number: "رقم رمز الاستجابة السريعة",
	qr_parking: "QR موقف سيارات",
	login_number: "رقم تسجيل الدخول",
	qr_code_grouping: "تجميع رموز الاستجابة السريعة",
	one_time_price: "سعر لمرة واحدة",
	qr_code_valet: "خدمة رمز الاستجابة السريعة",
	leave: "مغادرة",
	ready: "جاهز",
	ready_for_pickup: "جاهز للاستلام",
	there_are_no_data: "لا يوجد بيانات",
	effective_date: "تاريخ الفاعلية",
	increment: "زيادة",
	previous_requests: "الطلبات السابقة",
	bank: "البنك",
	assign_allowances: "تعيين البدلات",
	number_of_players: "عدد اللاعبين",
	assign_date: "تاريخ التعيين",
	max: "الحد الأقصى",
	min: "الحد الأدنى",
	all_data: "جميع البيانات",
	requests_hr: "طلبات الموارد البشرية",
	fees: "رسوم",
	fee: "رسوم",
	in_maintanence: "في حالة الصيانة",
	basic_salary: "راتب اساسي",
	allowances: "بدلات",
	number_of_available_parking: "عدد مواقف السيارات المتاحة",
	assigned_staff: "الموظفون المعينون",
	price_per: "السعر لكل",
	floor: "الطابق",
	government: "المحافظه",
	events_schedule: "جدول الأحداث",
	licence_number: "رقم الرخصة",
	licence: "رخصة",
	car_image: "صوره السياره",
	licence_image: "صوره الرخصة",
	full_address: "العنوان الكامل",
	temporary_zone: "منطقة مؤقتة",
	hour: "ساعة",
	day: "يوم",
	vehicle_number: "رقم المركبة",
	vehicle_color: "لون المركبة",
	vehicle_images: "صور المركبة",
	entry_time: "وقت الدخول",
	exit_time: "وقت الخروج",
	total_parking_duration: "إجمالي مدة وقوف السيارات",
	assigned_driver: "السائق المُعيَّن",
	qr_code: "رمز الاستجابة السريعة",
	start_time: "وقت البدء",
	end_time: "وقت الانتهاء",
	event_start_date: "تاريخ بدء الحدث",
	event_end_date: "تاريخ انتهاء الحدث",
	event_start_time: "وقت بدء الحدث",
	event_end_time: "وقت انتهاء الحدث",
	alert_time: "وقت التنبيه",
	weddings: "حفلات الزفاف",
	private_events: "الفعاليات الخاصة",
	seasonal_events: "الفعاليات الموسمية",
	allowances_hr: "بدلات ساعات العمل",
	allowance_name: "اسم البدل",
	category_management: "إدارة الفئات",
	upload_image_admin: "تحميل الصورة (الرخصة/الهوية المدنية)",
	admin_managment: "إدارة الموظفين",
	staff_management: "إدارة الموظفين",
	zones_managment: "إدارة المناطق",
	parking: "حجوزات المواقف",
	parking_slots: "موقف السيارات",
	parking_slot: "موقف السيارات",
	parking_movement: "حركة وقوف السيارات",
	drivers_managment: "إدارة السائقين",
	drivers_management: "إدارة السائقين",
	drivers: "السائقين",
	driver: "سائق",
	reports: "التقارير",
	push_notification: "إشعار الدفع",
	parent: "أب",
	student: "طالب",
	platform: "منصة",
	has_allowances: "لديه بدلات",
	allowances_setting: "إعداد البدلات",
	payment_start_date: "تاريخ بدء الدفع",
	freez: "تجميد",
	not_started: "لم يتم البدء",
	allowances_options: "خيارات البدلات",
	allowances_in_vacations: "البدلات في الإجازات",
	allowances_in_sick_leave: "البدلات في الإجازة المرضية",
	allowances_not_in_vacations: "البدلات غير في الإجازات",
	allowances_not_in_sick_leave: "البدلات غير في إجازة مرضية",
	excluded_employees_from_setting: "الموظفون المستبعدون من الإعداد",
	increase: "زياده",
	no_of_installments: "عدد الأقساط",
	installments: "الأقساط",
	loans: "قروض",
	loan: "قرض",
	remaining_installment: "القسط المتبقي",
	remaining: "المتبقي",
	has_loans: "لديه قروض",
	loans_history: "تاريخ القروض",
	human_resources: "الموارد البشرية",
	holiday: "أجازات",
	passport_no: "رقم جواز السفر",
	hr_name: "اسم الHr",
	employer_name: "اسم صاحب العمل",
	employee_letters: "خطابات الموظف",
	login_details: "تفاصيل تسجيل الدخول",
	passport_expiry_date: "تاريخ انتهاء صلاحية جواز السفر",
	date_of_join: "تاريخ الانضمام",
	personal_informations: "معلومات شخصية",
	benefits: "فوائد",
	bonus: "مكافأة",
	annual: "سنوي",
	attendance: "الحضور",
	attendance_hr: "ساعات الحضور",
	admin_updated_successfully: "تم تحديث المشرف بنجاح",
	provision: "توفير",
	hall_break: "استراحة القاعة",
	break: "استراحة",
	break_duration: "مدة الاستراحة",
	time_in_minutes: "الوقت بالدقائق",
	supervisors_type: "نوع المشرفين",
	boy: "ولد",
	girl: "بنت",
	none: "لا شيء مما سبق",
	no_of_students: "عدد الطلاب",
	after_number_of_classes: "بعد أي الفصول الدراسية",
	assign_employee: "تعيين موظف",
	number_of_employees: "عدد الموظفين",
	paid: "مدفوع",
	replace_employee: "استبدال الموظف",
	pos: "نقطة البيع",
	test_appointment: "موعد الاختبار",
	illustration: "صورة توضيحية",
	package_price: "سعر الباقات",
	day_price: "سعر اليوم",
	week_price: "سعر الأسبوع",
	month_price: "سعر الشهر",
	track_id: "Track ID",
	track: "مسار",
	tran_id: "Tran ID",
	date: "اليوم",
	not_paid: "غير مدفوع",
	maintaince_start_date: "تاريخ بدأ الصيانه",
	maintaince_end_date: "تاريخ انتهاء الصيانه",
	indemnity: "تعويض",
	contract_no: "رقم العقد",
	start_day: "يوم البدء",
	end_day: "يوم الإنتهاء",
	expiry_date: "تاريخ الانتهاء",
	nationality: "الجنسيه",
	employee_credentials: "بيانات اعتماد الموظف",
	package_num: "رقم الباقه",
	salary_certificate: "شهادة الراتب",
	company_projects: "مشاريع الشركة",
	existing_projects: "المشاريع القائمة",
	hosting_projects: "المشاريع المستضيفة",
	hosting: "مستضيفة",
	server: "الخادم",
	leave_balance: "رصيد الإجازة",
	on_vaction: "في الإجازة",
	vacation_history: "تاريخ الإجازة",
	history: "تواريخ",
	approved: "تمت الموافقه",
	rejected: "تم رفضه",
	approve: "موافقة",
	reject: "رفضت",
	leads: "قيادات",
	all: "الكل",
	cancellation_of_resignation: "إلغاء الاستقالة",
	notice_period: "فترة إشعار",
	resignation: "استقاله",
	start_resignation_date: "تاريخ بدء الاستقالة",
	end_resignation_date: "تاريخ انتهاء الاستقالة",
	lead_name: "اسم القياده",
	reference: "مرجع",
	revenues: "ايرادات",
	delete_date: "تاريخ الحذف",
	year: "السنه",
	year_revenues: "الايرادات السنويه",
	custody: "العهده",
	expenses: "مصاريف",
	year_expenses: "مصاريف السنويه",
	financial: "المالي",
	client_email: "بريد الكتوني العميل",
	total_salaries: "إجمالي الرواتب",
	contract_date: "ميعاد العقد",
	upload_contract: "تحميل العقد",
	upload_image: "تحميل الصوره",
	client_civil_id: "الرقم المدني للعميل",
	att_alert: "يرجي ادخال صورتين",
	from_front: "من الأمام",
	from_back: "من الخلف",
	back: "إلي الخلف",
	freeze: "تجميد",
	profits: "الأرباح",
	after: "بعد",
	payment_link: "رابط الدفع",
	projects: "مشاريع",
	employees_on_vacation: "الموظفين في إجازة",
	personal_email: "بريد الكتروني الشخصي",
	company_email: "بريد الكتروني الشركه",
	company: "الشركه",
	project: "مشروع",
	deduction: "الخصم",
	project_name: "اسم المشروع",
	client_name: "اسم العميل",
	employee_name: "اسم الموظف",
	client_phone: "هاتف العميل",
	salary: "راتب",
	salaries: "رواتب",
	maintaince: "صيانه",
	department: "قسم",
	emergency_leave: "الإجازة الطارئة",
	annual_leave: "الإجازة السنوية",
	reason: "السبب",
	departments: "أقسام",
	assets: "أصول",
	employees: "الموظفين",
	employee: "الموظف",
	request_sick_leave: "لقد قدم طلبات للحصول على إجازة مرضية لمده",
	request_salary_certificate: "لقد قدم طلبًا لإصدار شهادة راتب",
	is_requesting: "يطلب",
	for: "لمده",
	days: "أيام",
	choiceـshowroom: "اختيار صاله العرض",
	dashboard: "الصفحه الرئيسيه",
	admins: "المدراء",
	admin: "المشرف",
	rules: "صلاحيات",
	users: "المستخدمين",
	user: "مستخدم",
	categories: "التصنيفات",
	category: "التصنيف",
	sub_categories: "التصنيفات الفرعيه",
	sub_category: "التصنيف الفرعي",
	brands: "العلامات التجارية",
	variant: "اضافات",
	dynamic_variant: "اضافات بسعر",
	products: "المنتجات",
	products_sub: "المنتجات",
	product: "المنتج",
	booking: "الحجز",
	digital_products: "المنتجات الرقمية",
	reports: "التقارير",
	notification: "الاشعارات",
	notifications: "الاشعارات",
	time_slot: "اوقات العمل",
	times: "اوقات",
	banners: "لافتات",
	website_banners: "لافتات الموقع",
	members: "أعضاء",
	ad_screen: "اعلانات",
	apply_filter: "تطبيق الفلتر",
	clear_filter: "مسح الفلتر",
	filter: "الفلتر",
	job: "وظيفه",
	job_title: "المسمي الوظيفي",
	control: "تحكم",
	setting: "اعدادات",
	delivery: "توصيل",
	entry_tiem: "وقت الدخول",
	social_media: "وسائل التواصل",
	social: "وسائل التواصل",
	currency: "العمله",
	payment: "الدفع",
	pay: "دفع",
	pending: "قيد الانتظار",
	prepare_car: "تحضير السيارة",
	payment_type: "طرق الدفع",
	pages: "الصفحات",
	total_users: "إجمالي المستخدمين",
	total_categories: "إجمالي التصنيفات",
	total_sub_categories: "إجمالي التصنيفات",
	total_brands: "إجمالي العلامات التجارية",
	total_admins: "إجمالي المدراء",
	gmail: "بريد إلكتروني",
	total_activities_and_events: "إجمالي الأنشطة والفعاليات",
	total_board_of_directors: "إجمالي مجلس الإداره",
	total_branches_and_markets: "إجمالي الفروع والأسواق",
	total_news: "إجمالي الأخبار",
	total_offers: "إجمالي العروض",
	on_the_way: "في الطريق",
	canceled: "ألغيت",
	delivered: "تم التوصيل",
	shipped: "تم الشحن",
	process: "يتم المعالجه",
	ordered: "تم الطلب",
	total_sales: "إجمالي المبيعات",
	total_salary: "إجمالي المرتب",
	sales: "المبيعات",
	daily: "يومي",
	add_admin: "إضافة مشرف",
	add_admins: "إضافة مشرفين",
	name: "الإسم",
	first_name: "الإسم الاول",
	last_name: "الإسم الآخير",
	email: "بريد إلكتروني",
	address: "الموقع",
	address_link: "رابط الموقع",
	vacation: "أجازة",
	vacations: "الأجازات",
	accrued_leave: "أجازات مستحقه",
	sick_leave: "أجازة مرضية",
	is_sick: "مريض",
	sick: "مريض",
	sick_history: "التاريخ المرضي",
	departure_day: "يوم الرحيل",
	return_day: "يوم العوده",
	diwans: "الدواوين",
	shareholders: "المساهمين",
	shareholders_requests: "طلبات المساهمين",
	requests: "الطلبات",
	attachments: "مرفقات",
	number_of_people: "عدد الافراد",
	people: "عدد الافراد",
	number_of_days: "عدد الايام",
	print: "طباعه",
	membership_number: "رقم العضويه",
	item_no: "رقم الصنف",
	item: "صنف",
	items: "أصناف",
	barcode: "باركود",
	product_name: "اسم المنتج",
	import: "استيراد",
	phone: "رقم التليفون",
	password: "الرقم السري",
	new_password: "الرقم السري الجديد",
	confirm_password: "تأكيد الرقم السري",
	no_of_payments_made: "عدد المدفوعات التي تم إجراؤها",
	user_name: "اسم المستخدم",
	note: "ملحوظه",
	commission: "عمولة",
	termination: "الإنهاء",
	end_of_service: "نهاية الخدمة",
	organization: "تنظيم",
	change_password: "تغيرر الرقم السري",
	country_code: "كود الدوله",
	permissions: "الأذونات",
	unpaid_vacation: "إجازة غير مدفوعة الأجر",
	loan_installment: "قسط القرض",
	status: "حالة",
	details: "تفاصيل",
	payroll_salary: "كشف الرواتب",
	salary_slip: "وصل الراتب",
	rule: "إذن",
	full_time: "دوام كامل",
	part_time: "دوام جزئي",
	full_permissions: "أذونات كاملة",
	civil_id: "الرقم المدني",
	employee_id: "رقم هوية الموظف",
	box_number: "رقم الصندوق",
	family_card: "بطاقة العائلة",
	shareholder_code_number: "كود رقم المساهم",
	some_permissions: "بعض الأذونات",
	no_permissions: "لا أذونات",
	new: "جديد",
	works_hours: "ساعات العمل",
	works_day: "أيام العمل",
	read_only: "قراءه فقط",
	edit: "تعديل",
	delete: "مسح",
	search_by: "البحث عن طريق",
	profile: "الحساب الشخصي",
	logout: "تسجيل الخروج",
	cancel: "إلغاء",
	submit: "إضافه",
	add: "إضافه",
	view: "رؤية",
	select: "اختار",
	deleted: "تم الحذف",
	next: "التالي",
	previous: "السابق",
	go_to_page: "الذهاب الي صفحه",
	page: "صفحه",
	of: "من",
	add_categories: "إضافة تصنيف",
	active: "نشط",
	not_active: "غير نشط",
	image: "الصوره",
	month: "الشهر",
	remove: "مسح",
	assigned_products: "المنتجات المخصصة",
	remove_image: "تم مسح الصوره",
	deactive: "تعطيل",
	english: "اللغه الانجليزيه",
	arabic: "اللغه العربيه",
	category_image: "صوره التصنيف",
	close: " اغلاق",
	price: "السعر",
	in_stock: "متوفره",
	english_title: "العنوان باللغة الانجليزية",
	english_name: "الإسم باللغة الانجليزية",
	arabic_title: "العنوان باللغة العربية",
	arabic_name: "الإسم باللغة العربية",
	english_description: "الوصف باللغة الإنجليزية",
	arabic_description: "الوصف باللغة العربية",
	description: "الوصف",
	activities: "الأنشطه",
	activity: "نشاط",
	branches_and_markets: "الفروع والأسواق",
	code: "كود المنتج",
	cost: "التكلفه",
	quantity: "كمية",
	weight: "وزن",
	offer_price: "سعر العرض",
	best_seller: "الأكثر مبيعًا",
	new_in: "الجديد في",
	offer: "عرض",
	offers: "العروض",
	contact_us: "تواصل معنا",
	talabat: "طلبات",
	images: "الصور",
	create: "إنشاء",
	you_tube: "يوتيوب",
	types_by_english: "أنواع باللغة الإنجليزية",
	types_by_arabic: "أنواع باللغة العربية",
	add_new_value: "إضافة قيمة جديدة",
	chosse: "اختيار",
	has_amount: "لديه كميه",
	amount: "الكميه",
	available_amount: "الكميه المتاحه",
	payment_method: "طريقه الدفع",
	payment_methods: "طرق الدفع",
	kwd: "دينار كويتي",
	total_price: "السعر الكلي",
	sub_price: "السعر الجزئي",
	total: "الكلي",
	customer_name: "إسم العميل",
	exist_user: "عميل موجود",
	new_user: "عميل جديد",
	search: "بحث",
	order_day: "يوم التوصيل",
	from: "من",
	to: "إلي",
	coupon: "كود الخصم",
	verified: "تم التحقق",
	updated_successfully: "تم التحديث بنجاح",
	updated_status_successfully: "تم تحديث الحالة بنجاح",
	profile_updated_successfully: "تم تحديث الملف الشخصي بنجاح",
	banners_updated_successfully: "تم تحديث اللافتات بنجاح",
	banners_added_successfully: "تم إضافه اللافتات بنجاح",
	added_successfully: "تم إضافه بنجاح",
	apply: "تطبيق",
	enter: "أدخل",
	add_new_product: "إضافه منتج جديد",
	date_range: "المده",
	export: "تصدير",
	visa: "فيزا",
	cash: "كاش",
	type: "النوع",
	end_date: "تاريخ الإنتهاء",
	start_date: "تاريخ البدأ",
	max_usage: "الاستخدام الأقصى",
	count_usage: "عدد الإستخدام",
	percentage: "نسبة مئوية",
	fixed: "نسبة ثابته",
	net_profit: "صافي الربح",
	or: "أو",
	serial_number: "الرقم التسلسلي",
	serial_image: "الصورة التسلسلية",
	title: "العنوان",
	message: "الرساله",
	send: "إرسال",
	delete_message:
		"يرجى ملاحظة أنه لا يمكن التراجع عن هذا الإجراء وسيتم حذف التفاصيل.",
	welcome_back: "مرحبا بعودتك",
	sign_text: "قم بتسجيل الدخول عن طريق إدخال المعلومات أدناه",
	text: "أعمال جيدة جدا في انتظاركم",
	sign_in: "تسجيل الدخول",
	login: "تسجيل الدخول",
	specific_block: "يوم العطله",
	capacity: "سعه",
	interval: "فاصلة",
	open: "فتح",
	rate: "معدل",
	country_name: "اسم الدولة",
	country: "الدولة",
	banner: "لافته",
	link: "رابط",
	ad: "إعلان",
	add_new_screen: "إضافه شاشه أخري",
	website_title: "عنوان موقع الويب",
	website_logo: "شعار موقع الويب",
	mobile_logo: "شعار الجوال",
	dashboard_logo: "شعار لوحة المعلومات",
	color: "اللون",
	label_color: "لون النصوص",
	possible_delivery: "امكانيه التوصيل",
	cash_in_delivery_fees: "رسوم تسليم النقد",
	shipping_fee: "رسوم الشحن",
	price_per_kg: "السعر للكيلو جرام",
	type_of_area: "نوع المنطقة",
	all_area: "لكل المناطق",
	per_area: "للمنطقة",
	delivery_fees: "رسوم التوصيل",
	facebook: "فيسبوك",
	snapchat: "سناب شات",
	instagram: "إنستغرام",
	whatsapp: "واتس اب",
	twitter: "تويتر",
	with: "مع",
	and: "و",
	linked_in: "لينكد إن",
	telegram: "تيليجرام",
	tiktok: "تيك توك",
	app_store: "متجل أبل",
	play_store: "متجر جوجل",
	call_us: "اتصل بنا",
	iban: "رقم الآيبان",
	about: "حول",
	cms: "نظام إدارة المحتوى",
	blogs: "المدونات",
	blog: "مدونه",
	gallery: "المعرض",
	faqs: "الأسئلة الشائعة",
	privacy: "الخصوصية",
	url: "عنوان URL",
	public_matches: "مباريات عامة",
	public: "عامة",
	private_matches: "مباريات خاصة",
	match: "مباراة",
	privacy_policy: "سياسة الخصوصية",
	address_name: "العنوان",
	block: "القطعة",
	street: "الشارع",
	area: "المنطقة",
	first: "أولا",
	avenue: "الجادة",
	building_number: "رقم المبنى",
	floor_number: "رقم الطابق",
	office_number: "رقم المكتب",
	house_number: "رقم المنزل",
	apt_number: "رقم الشقة",
	other_instructions: "تعليمات أخرى",
	delivery_day: "يوم التوصيل",
	time: "الوقت",
	confirm_added: "تأكيد الإضافة",
	added: "إضافة",
	confirm_des: "يمكنك إضافة منتج آخر عن طريق تغيير بعض المعلومات",
	add_more_products: "أضف المزيد من نفس المنتج",
	reference_id: "الرقم المرجعي",
	invoice_id: "رقم الفاتورة",
	post_date: "التاريخ",
	createdAt: "أنشئت في",
	order_id: "رقم الطلب",
	static_pages: "الصفحات الثابته",
	field_required: "هذا الحقل مطلوب",
	ordered_successfully: "تم الطلب بنجاح",
	successfully: "بنجاح",
	ordered_failed: "فشل الطلب",
	failed_msg: "عمليه الدفع لم تكتمل",
	back_home: "العودة إلى الصفحة الرئيسية",
	knet: "كي نت",
	bidding_management: "إدارة عروض الأسعار",
	app_commission_management: "إدارة عمولة التطبيق",
	wallet_management: "إدارة المحفظة",
	brand_management: "إدارة العلامة التجارية",
	time_management: "إدارة الوقت",
	location: "الموقع",
	website: "موقع إلكتروني",
	january: "يناير",
	february: "فبراير",
	march: "مارس",
	april: "ابريل",
	may: "مايو",
	june: "يونيو",
	july: "يوليو",
	august: "أغسطس",
	september: "سبتمبر",
	october: "أكتوبر",
	november: "نوفمبر",
	december: "ديسمبر",
	daily_indemnity: "التعويض اليومي",
	exceeding_years_indemnity: "تعويض السنوات التجاوز",
	first5YearsIndemnity: "تعويض السنوات الخمس الأولى",
	monthly: "شهري",
	monthly_indemnity: "التعويض الشهري",
	paid_leave_balance_amount: "مبلغ رصيد الإجازة المدفوعة",
	total_indemnity: "التعويض الإجمالي",
	civil_id_status: "حالة البطاقة المدنية",
	passport_status: "حالة جواز السفر",
	residency_status: "حالة الإقامة",
	valid: "صالح",
	expired: "منتهية الصلاحية",
	admin_management: "إدارة المشرف",
	recent_transactions: "المعاملات الأخيرة",
	action: "فعل",
	orders: "طلبات",
	admin_settings: "إعدادات المشرف",
	branches: "الفروع",
	branch: "الفرع",
	branch_no: "رقم الفرع",
	branch_manager: "مدير الفرع",
	work_shift: "شيفتات",
	gates_no: "عدد البوابات",
	gate_no: "رقم البوابه",
	branch_name: "اسم الفرع",
	branch_details: "تفاصيل الفرع",
	quick_valet: "الخدمة السريعة",
	brand_model: "نموذج العلامة التجارية",
	quick_valet_price: "سعر الخدمة السريعة",
	branch_id: "الفرع ID",
	shift: "الوردية",
	facilities: "المرافق",
	halls: "القاعات",
	job_titles: "المسميات الوظيفية",
	roles: "الصلاحيات",
	role: "صلاحيه",
	created_on: "تم الإنشاء في",
	hr_plans: "خطط الموارد البشرية",
	hr_letters: "خطابات الموارد البشرية",
	organization_chart: "الهيكل التنظيمي",
	teacher_management: "إدارة المعلمين",
	zones: "مناطق",
	executive_plan: "الخطة التنفيذية",
	teachers: "مدرسون",
	teacher: "مدرس",
	pos_management: "إدارة نقاط البيع",
	pos: "نقاط البيع",
	pos_reports: "تقارير نقاط البيع",
	pos_reports_sub: "تقارير نقاط البيع",
	effective_users: "المستخدمون الفعالون",
	operation_management: "إدارة العمليات",
	operations: "العمليات",
	vehicles: "المركبات",
	support_services: "خدمات الدعم",
	monitoring: "المراقبة",
	medical_care: "الرعاية الطبية",
	program_management: "إدارة البرنامج",
	supervisors: "المشرفون",
	education: "التعليم",
	entertainment: "الترفيه",
	groups: "المجموعات",
	night_revision: "المراجعة الليلية",
	early_leave_emergency: "الإجازة المبكرة والطوارئ",
	variants: "المتغيرات",
	add_on_group: "مجموعة الإضافات",
	coupons: "الكوبونات",
	inventory: "المخزون",
	stocks: "المخزون",
	purchases: "المشتريات",
	warehouse: "المستودع",
	sales_dashboard: "لوحة معلومات المبيعات",
	complaints: "الشكاوى",
	email_tracking: "تتبع البريد الإلكتروني",
	contacts: "جهات الاتصال",
	contacts_crm: "جهات الاتصال",
	referral: "إحالة",
	campaign: "حملة",
	deals: "الصفقات",
	crm: "إدارة علاقات العملاء",
	suppliers: "الموردون",
	chart_of_accounts: "مخطط الحسابات",
	financial_year: "السنة المالية",
	company_logo: "شعار الشركة",
	work_shifts: "نوبات العمل",
	contract_types: "أنواع العقود",
	request_types: "أنواع الطلبات",
	settings: "إعدادات",
	sales_report: "تقرير المبيعات",
	purchase_report: "تقرير المشتريات",
	products_report: "تقرير المنتجات",
	suppliers_report: "تقرير الموردين",
	attendance_report: "تقرير الحضور",
	salaries_report: "تقرير الرواتب",
	documents: "وثائق",
	alerts: "تنبيهات",
	units: "وحدات",
	unit: "وحده",
	department_name: "اسم القسم",
	unit_name: "اسم الوحدة",
	department_manager: "مدير القسم",
	no_of_units: "عدد الوحدات",
	no_of_employees: "عدد الموظفين",
	unit_manager: "مدير الوحدة",
	facility: "مرفق",
	facility_type: "نوع المرفق",
	facility_plan: "خطه المرفق",
	scheduled_time: "الوقت المجدول",
	assigned_branches: "الفروع المخصصة",
	owner: "مالك",
	legal_name: "الاسم القانوني",
	authorised_signatory: "المفوض بالتوقيع",
	establishment_date: "تاريخ التأسيس",
	fields_of_work: "مجالات العمل",
	fax_number: "رقم الفاكس",
	year_days: "أيام السنة",
	license_number: "رقم الترخيص",
	commercial_registration: "السجل التجاري",
	legal_office: "المكتب القانوني",
	save: "حفظ",
	hall: "القاعة",
	hall_name: "اسم القاعة",
	hall_no: "رقم القاعة",
	program_type: "نوع البرنامج",
	capacity_assumption: "افتراض السعة",
	gender: "الجنس",
	coach: "مدرب",
	time_from: "الوقت من",
	time_to: "الوقت إلى",
	number_of_classes: "عدد الصفوف",
	class: "الصف",
	interval_between_classes: "الفاصل الزمني بين الفصول",
	number: "رقم",
	hall_details: "تفاصيل القاعة",
	organization_color: "لون التنظيم",
	Total_active_students: "إجمالي الطلاب النشطين",
	Available_programs_and_camps: "البرامج والمعسكرات المتاحة",
	Available_Educational_Courses: "الدورات التعليمية المتاحة",
	Max: "الحد الأقصى",
	Words: "كلمات",
	Word: "كلمة",
	max_size: "الحد الأقصى للحجم",
	mbs: "ميجا بايت",
	num_of_images: "عدد الصور",
	banner_image: "صورة البانر",
	max_number: "الحد الأقصى",
	published: "نُشر",
	drafted: "مسودة",
	add_new_position: "إضافة وظيفة جديدة",
	position: "وظيفة",
	position_applied: "الوظيفة التي تقدمت لها",
	positions: "وظائف",
	optional: "اختياري",
	for_hiring: "للتوظيف",
	contact: "تواصل",
	confirm: "تأكيد",
	sales_email: "بريد إلكتروني للمبيعات",
	support_email: "بريد إلكتروني للدعم",
	call_number: "رقم الاتصال",
	another_call_number: "رقم اتصال آخر",
	inquiry: "الاستعلام",
	suggestion: "الاقتراح",
	complaint: "شكوى",
	job_application: "طلب وظيفة",
	cv: "تحميل السيرة الذاتية",
	subject: "الموضوع",
	closed: "مغلق",
	platform_social_links: "روابط منصات التواصل الاجتماعي",
	whatsapp_link: "رابط واتساب",
	instagram_link: "رابط انستجرام",
	facebook_link: "رابط فيسبوك",
	iOS_download_link: "رابط تنزيل IOS",
	android_download_link: "رابط تنزيل Android",
	terms_conditions: "الشروط والأحكام",
	terms_privacy: "الشروط والخصوصية",
	programs: "البرامج",
	program: "البرنامج",
	subjects: "المواد",
	education_type: "نوع التعليم",
	grade: "الصف",
	grades: "الفصول",
	program_name: "اسم البرنامج",
	multi_select: "اختيار متعدد",
	choose: "اختار",
	at_home: "في المنزل",
	at_center: "في المركز",
	online: "عبر الانترنت",
	program_start_date: "تاريخ بدء البرنامج",
	program_end_date: "تاريخ انتهاء البرنامج",
	foundation: "الأساس",
	curriculum: "المنهج الدراسي",
	program_classification: "تصنيف البرنامج",
	group: "مجموعة",
	private: "خاص",
	hall_type: "نوع القاعة",
	single: "مفرد",
	multi: "متعدد",
	age_group: "الفئة العمرية",
	group_settings: "إعدادات المجموعة",
	group_capacity: "سعة المجموعة",
	first_sub_group: "المجموعة الفرعية الأولى",
	accepted_years: "سنوات القبول",
	on_group: "على المجموعة",
	group_product_name: "اسم منتج المجموعة",
	assign_subject_to_hall: "تعيين الماده للقاعة",
	second_sub_group: "المجموعة الفرعية الثانية",
	supervisor_span: "نطاق المشرف",
	programs_note:
		"إذا حجز الطالب برنامجًا، فلا يُمكن حذفه. لا يُمكن حذف البرنامج إلا إذا لم يكن لديه أي حجز.",
	subjects_note:
		"لا يجوز للطالب حضور المواد الدراسية في نفس الفئة في نفس اليوم.",
	program_details: "تفاصيل البرنامج",
	group_name: "اسم المجموعة",
	coash: "مدرب",
	enable_capacity_assumption: "تمكين افتراض القدرة",
	hall_classification: "تصنيف القاعة",
	gate_name: "إسم البوابه",
	assign: "تعيين",
	reassign: "إعادة التعيين",
	join_card: "بطاقة الانضمام",
	assign_manager: "تعيين مدير",
	allowance_time: "وقت البدل",
	contract_type: "نوع العقد",
	duration: "المدة",
	lessons_frequency_week: "تكرار الدروس/الإسبوع",
	academic_qualifications: "المؤهلات الأكاديمية",
	job_information: "معلومات الوظيفة",
	photo: "صوره",
	joining_date: "تاريخ الانضمام",
	academic_degree: "الدرجة الأكاديمية",
	specialization: "التخصص",
	university: "الجامعة",
	teaching_certification: "شهادة التدريس",
	years_of_experience: "سنوات الخبرة",
	add_additional_skills: "إضافة مهارات إضافية",
	additional_licence: "رخصة إضافية",
	upload_max3: "تحميل الحد الأقصى 3",
	set_as_manager: "تعيين كمدير",
	yes: "نعم",
	no: "لا",
	annual_vacation: "إجازة سنوية",
	annually: "سنوي",
	personal_info: "معلومات شخصية",
	male: "ذكر",
	female: "أنثى",
	mixed: "مختلط",
	bachelors: "بكالوريوس",
	master: "ماجستير",
	phd: "دكتوراه",
	diploma: "دبلوم",
	high_school: "مدرسة ثانوية",
	associate: "زمالة",
	other: "آخر",
	supervisor: "المشرف",
	manager: "المدير",
	kuwait: "الكويت",
	kwt: "الكويت",
	british: "بريطانية",
	american: "أمريكية",
	draft: "مسودة",
	e_commerce: "التجارة الإلكترونية",
	category_name: "اسم الفئة",
	color_code: "رمز اللون",
	sku: "رقم المنتج",
	qty: "كمية",
	physical_product: "منتج مادي",
	digital_product: "منتج رقمي",
	service_product: "منتج خدمي",
	packages_product: "باقات المنتج",
	discount: "تخفيض",
	stock: "مخزون",
	available_for_delivery: "متاح للتسليم",
	has_variant: "لديه متغير",
	course_name: "اسم الدورة",
	video_name: "اسم الفيديو",
	has_price: "لديه السعر",
	upload_video: "تحميل الفيديو",
	duration_of_video: "مدة الفيديو",
	number_of_videos: "عدد الفيديوهات",
	service_name: "اسم الخدمة",
	with_qty: "مع الكمية",
	free_of_qty: "خالي من الكمية",
	package_name: "اسم الباقه",
	features: "الميزات",
	zone_group: "مجموعة المناطق",
	zone_groups: "مجموعات المناطق",
	zone: "المنطقة",
	zones_name: "اسم المناطق",
	number_of_semester: "عدد الفصل الدراسي",
	name_of_semester: "إسم الفصل الدراسي",
	academic_year: "السنة الدراسية",
	start_year: "سنة البدء",
	finish_year: "سنة الانتهاء",
	semester_info: "معلومات الفصل الدراسي",
	choose_education_type: "اختر نوع التعليم",
	semester_details: "تفاصيل الفصل الدراسي",
	semeseter: "الفصل الدراسي",
	semester: "الفصل الدراسي",
	exam_nights: "ليالي الامتحان",
	final_revision: "المراجعة النهائية",
	availability_time: "وقت التوف",
	teacher_info: "معلومات المعلم",
	owns_a_car: "يملك سيارة",
	doesnot_own_a_car: "لا يملك سيارة",
	wamd_number: "رقم Wamd",
	availability_time_in_each_semester: "التوفر الوقت في كل فصل دراسي",
};
